import React, { useEffect, useState } from "react";
import { ShoppingCart } from "react-feather";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl"; 


// Custom Arrow Button
const ArrowButton = ({ className, style, onClick, icon }) => {
  return (
    <button
      className={className}
      style={{ ...style, display: 'block', background: 'transparent', border: 'none', color: '#fff',
        backgroundColor: "#000000d3" }}
      onClick={onClick}
    >
      {icon}
    </button>
  );
};


const FeaturedProduct = () => { 

const [listings, setListings] = useState([]);

  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };
 
useEffect(() => {
    const fetchListings = async () => {
      try {
        const res = await axios.get(`${baseurl}getHomePageListings`);
        const data = res.data?.listings || [];

        const filtered = data
          .filter((item) => item.sale_type === "Featured Product")
          .sort((a, b) =>
            b.created_at && a.created_at
              ? new Date(b.created_at) - new Date(a.created_at)
              : b.listing_id - a.listing_id
          )
          .slice(0, 8);

        setListings(filtered);
      } catch (error) {
        console.error("Error fetching listings:", error);
      }
    };

    fetchListings();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    prevArrow: <ArrowButton className="slick-prev" icon="❮" />,
    nextArrow: <ArrowButton className="slick-next" icon="❯" />,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 992, // Tablet
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Large Mobile
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // Small Mobile
        settings: {
          slidesToShow: 2 ,
        },
      },
    ],
  };

  const renderCard = (Listing) => {
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
    const findFirstImage = (images) =>
      images.find((img) =>
        imageExtensions.some((ext) => img.toLowerCase().endsWith(ext))
      );
    const imageToDisplay =
      findFirstImage(Listing.images) || "default-image.jpg";

    return (
      <div key={Listing.listing_id} className="p-2">
        <div className="product-card">
          <img
            src={`${imageUrl}listing/${imageToDisplay}`}
            alt={Listing.title}
          />

          <div className="p-2">
 <p className="brand">{Listing.brand_name}</p>
          <h3 className="mytitle">{Listing.title}</h3>
 
           <div className="d-flex justify-content-between align-items-center">
            <Link to={`/product/${Listing.slug}`} className="shop-now-text">
              Shop Now
            </Link>
            <Link to={`/product/${Listing.slug}`} className="shop-now-arrow">
              →
            </Link>
          </div>
 
          </div> 
        </div>
      </div>
    );
  };

  return (
    <div className="mt-3">
      <Slider {...settings}>
        {listings.map((Listing) => renderCard(Listing))}
      </Slider>
    </div>
  );
};

export default FeaturedProduct;
